import { render, staticRenderFns } from "./cardLqzsr.vue?vue&type=template&id=0f02abb4&scoped=true"
import script from "./cardLqzsr.vue?vue&type=script&lang=js"
export * from "./cardLqzsr.vue?vue&type=script&lang=js"
import style0 from "./cardLqzsr.vue?vue&type=style&index=0&id=0f02abb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f02abb4",
  null
  
)

export default component.exports